import _ from "lodash";

function getResultsById(data) {
  if (!data || !Array.isArray(data)) {
    return {};
  }
  return _.reduce(
    data,
    (accumulator, currentValue) => {
      if (!currentValue) {
        return accumulator;
      }
      const { id, results } = currentValue;
      if (!results || !Array.isArray(results)) {
        return { ...accumulator, [id]: {} };
      }
      const resultsPerId = _.reduce(
        results,
        (acc, item) => {
          if (!item || !item.answers) {
            return acc;
          }
          const { inputName, value } = item.answers;
          if (!inputName) {
            return acc;
          }
          return { ...acc, [inputName]: { inputName, value } };
        },
        {}
      );
      return { ...accumulator, [id]: resultsPerId };
    },
    {}
  );
}
export default getResultsById;



// WEBPACK FOOTER //
// ./src/components/Admin/surveys/Results/ResultsWithCharts/getResultsById.js